import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Lock, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useFirebaseAuthentication } from 'lib/firebase';
import { isAdmin } from 'lib/purchaseUtils';

const AdminRoute = ({ children }) => {
  const user = useFirebaseAuthentication();
  const navigate = useNavigate();

  // Show loading state while checking auth
  if (user === undefined) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  // Check if user is admin
  if (!user || !isAdmin(user)) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          p: 2,
        }}
      >
        <Paper
          elevation={8}
          sx={{
            p: 4,
            maxWidth: 400,
            textAlign: 'center',
            borderRadius: 4,
          }}
        >
          <Lock sx={{ fontSize: 64, color: '#dc3545', mb: 2 }} />
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            You don't have permission to access this admin area.
          </Typography>
          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={() => navigate('/')}
            sx={{
              bgcolor: '#667eea',
              '&:hover': { bgcolor: '#5a6fd8' },
              borderRadius: 2,
            }}
          >
            Go Home
          </Button>
        </Paper>
      </Box>
    );
  }

  // User is admin, render the protected content
  return children;
};

export default AdminRoute;